import { Icon } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getProjetoActionsS3ApiUrl } from 'store/modules/ProjetoActions';
import { getMergedClassNames } from 'utils/HTMLUtils';
import { getUniqueKey } from 'utils/NumberUtils';
import { generateVideoThumbnail } from 'utils/videoUtils';
import { typeIsImage, typeIsVideo } from '../../utils/FileUtils';
import CloseIcon from '../Icons/CloseIcon';
import VideocamIcon from '../Icons/VideocamIcon';
import TooltipCaller from '../TooltipManager/TooltipCaller';
import { Col } from './../Col';
import styles from './FileItem.scss';
const rootClassName = styles.rootClassName;

export const UPLOAD_STATUS_WAITING = 1;
export const UPLOAD_STATUS_UPLOADING = 2;
export const UPLOAD_STATUS_DONE = 3;
export const UPLOAD_STATUS_ERROR = 4;

class FileItem extends Component {
  constructor(props) {
    super(props);
    this.id = getUniqueKey();
    this.state = {
      base64: null,
    };
    this.controller = new AbortController();
  }

  UNSAFE_componentWillMount() {
    if (
      this.props.file.status === UPLOAD_STATUS_WAITING ||
      this.props.file.status === UPLOAD_STATUS_UPLOADING
    ) {
      if (typeIsImage(this.props.file.tipo)) {
        this.loadFileBase64();
      }
    }
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  getThumbnailTooltipCaller(children) {
    if (this.props.file.status === UPLOAD_STATUS_ERROR) {
      return (
        <TooltipCaller
          text={
            this.props.file.messageError ||
            this.props.languageValues.imageUploadError
          }
          className={rootClassName + '-thumb-tooltip-caller'}
        >
          {children}
        </TooltipCaller>
      );
    }
    return children;
  }

  loadFileBase64() {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        ...this.state,
        base64: e.target.result,
      });
    };
    reader.readAsDataURL(this.props.file.file);
  }

  getLinkContainer(children) {
    const isImage = typeIsImage(this.props.file.tipo);
    const imageLink =
      this.props.file.status === UPLOAD_STATUS_DONE && this.props.file.caminho
        ? this.props.file.caminho
        : null;

    const getUrl = (compressed = false) => {
      if (this.state.base64) {
        return this.state.base64;
      }
      if (this.props.file.caminho) {
        const c = compressed ? this.props.file.caminhoCompressed : null;
        return getProjetoActionsS3ApiUrl() + '/' + (c ?? this.props.file.caminho);
      }
      return '';
    };

    const url = getUrl();

    if (!isImage) {
      generateVideoThumbnail(url, this.controller.signal)
        .then((thumbnailUrl) => {
          const el = document.getElementById(this.id);
          if (thumbnailUrl && el) {
            el.style.backgroundImage = `url(${thumbnailUrl})`;
          }
        })
        .catch((err) => {
          console.error('Não foi possível gerar a miniatura do vídeo', err);
        });
    }

    const thumbUrl = getUrl(true);

    return (
      <a
        id={this.id}
        className={getMergedClassNames([
          `${rootClassName}-image`,
          imageLink ? `${rootClassName}-image-link` : '',
        ])}
        style={{ backgroundImage: `url(${thumbUrl})` }}
        href={url}
        target='_blank'
        rel='noreferrer'
      >
        {children}
      </a>
    );
  }

  getThumbnail() {
    const getVideoIcon = () => {
      if (typeIsVideo(this.props.file.tipo)) {
        return <VideocamIcon className={rootClassName + '-video-icon'} />;
      }
      return '';
    };
    return this.getThumbnailTooltipCaller(
      this.getLinkContainer(
        <>
          {getVideoIcon()}
          {this.props.file.status !== UPLOAD_STATUS_DONE &&
            this.props.file.status !== UPLOAD_STATUS_ERROR ? (
            <div className={rootClassName + '-loading'}>
              {typeof this.props.file.percent === 'number'
                ? Math.round(this.props.file.percent)
                : 0}
              %
            </div>
          ) : (
            ''
          )}
        </>
      )
    );
  }

  getRemoveButton() {
    if (
      this.props.file.status === UPLOAD_STATUS_DONE ||
      this.props.file.status === UPLOAD_STATUS_ERROR
    ) {
      return (
        <TooltipCaller
          text={
            typeIsImage(this.props.file.tipo)
              ? this.props.languageValues.imageRemoveLabel
              : this.props.languageValues.videoRemoveLabel
          }
          className={rootClassName + '-tooltip-caller'}
        >
          <button
            disabled={this.props.disabled}
            onClick={() => {
              this.props.toRemove(this.props.file.caminho);
            }}
            className={rootClassName + '-remove-button'}
          >
            <CloseIcon />
          </button>
        </TooltipCaller>
      );
    }
    return '';
  }

  getCoverButton() {
    if (
      typeIsImage(this.props.file.tipo) &&
      this.props.file.status === UPLOAD_STATUS_DONE
    ) {
      return (
        <TooltipCaller
          text={this.props.languageValues.setStepCover}
          className={
            rootClassName +
            '-tooltip-caller-cover ' +
            (this.props.file.principal
              ? rootClassName + '-tooltip-caller-covered'
              : '')
          }
        >
          <button
            onClick={() => {
              this.props.toCover(this.props.file.caminho);
            }}
          >
            <Icon>{this.props.file.principal ? 'star' : 'star_border'}</Icon>
          </button>
        </TooltipCaller>
      );
    }
    return '';
  }

  actionButtonsIsShown() {
    if (this.props.freezed) {
      return false;
    }
    switch (this.props.status) {
      case UPLOAD_STATUS_WAITING:
      case UPLOAD_STATUS_UPLOADING:
        return false;
      default:
        return true;
    }
  }

  render() {
    let classNames = [rootClassName];
    if (this.props.file.status === UPLOAD_STATUS_DONE) {
      classNames.push(rootClassName + '-uploaded');
    }
    if (this.props.file.status === UPLOAD_STATUS_ERROR) {
      classNames.push(rootClassName + '-error');
    }
    return (
      <Col cols={[6, 4, 3, 2, 2]}>
        <div className={classNames.join(' ')}>
          {this.getThumbnail()}
          {this.actionButtonsIsShown() ? this.getRemoveButton() : null}
          {this.actionButtonsIsShown() ? this.getCoverButton() : null}
        </div>
      </Col>
    );
  }
}

FileItem.propTypes = {
  freezed: PropTypes.bool.isRequired,
  file: PropTypes.object.isRequired,
  toCover: PropTypes.func.isRequired,
  toRemove: PropTypes.func,
  status: PropTypes.number,
  disabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

export default connect(mapStateToProps)(FileItem);
